import type { SpeechType } from '../hooks/speechCategory';

interface Props {
  value: SpeechType;
  onChange: (next: SpeechType) => void;
}

const OPTIONS: SpeechType[] = ['script', 'convo', 'all'];

/**
 * Stage 11: segmented button group for switching the Speech Gallery
 * between SCRIPT (tool-generated clips), CONVO (per-turn chat audio),
 * and ALL (diagnostics).
 */
export function SpeechTabs({ value, onChange }: Props) {
  return (
    <nav
      className="speech-tabs"
      role="tablist"
      aria-label="Speech category"
    >
      {OPTIONS.map((opt) => (
        <button
          key={opt}
          type="button"
          role="tab"
          aria-selected={value === opt}
          className={value === opt ? 'btn-primary' : ''}
          onClick={() => onChange(opt)}
        >
          {opt.toUpperCase()}
        </button>
      ))}
    </nav>
  );
}
